import { Box } from '@mui/material'
import React from 'react'

function PaymentReceivedCORPORATE() {
  return (
    <Box m="40px"><h1>Payment Received</h1></Box>
  )
}

export default PaymentReceivedCORPORATE